export default __webpack_public_path__ + "static/media/orbit.ff0a0ebd.mp4";